import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { AmplitudeEvent } from 'utils/amplitude/amplitudeEvents'
import { useRewardsSheetContext } from '../context/RewardsSheetProvider'
import { useEarningWalletBalances } from '../hooks/api/useEarningWalletBalances'
import useRewardsTracking from '../hooks/useRewardsTracking'
import { RewardsActionIds } from '../types'
import { formatAPY } from '../utils'
import { RewardsAsset } from './RewardsAsset'

interface RewardsAssetsProps {
  title: string
  layout: 'grid' | 'list'
}

export const RewardsAssets = ({ title, layout }: RewardsAssetsProps) => {
  const { t } = useTranslation()
  const { trackClick } = useRewardsTracking()
  const { handleSheetOpen, rewardsProducts } = useRewardsSheetContext()
  const { totalAvailableByProduct, isLoading: isLoadingEarningWalletBalances } =
    useEarningWalletBalances(rewardsProducts)

  const handleDeposit = (currency: string) => {
    trackClick(AmplitudeEvent.REWARDS_ALLOCATE_FUNDS_INITIATE)
    handleSheetOpen({
      actionId: RewardsActionIds.DEPOSIT,
      header: t('rewards.deposit.header'),
      selectedCurrency: currency,
    })
  }

  return (
    <Box flexCol gapY={16}>
      <h4 className="text-h4 text-foreground-prominent">{title}</h4>
      <Box
        flexCol
        gap={16}
        className={clsx('lg:flex-row', layout === 'grid' ? 'grid grid-cols-2' : '')}
      >
        {rewardsProducts?.map(product => (
          <RewardsAsset
            key={product?.currency}
            availableAmount={{
              value: totalAvailableByProduct?.[product?.currency] || 0,
              loading: isLoadingEarningWalletBalances,
            }}
            currency={product?.currency}
            apyRate={formatAPY(product?.earningRate)}
            onDeposit={() => handleDeposit(product?.currency)}
          />
        ))}
      </Box>
    </Box>
  )
}
